import { useState } from 'react';
import { nowYM, ymAdd, ymd } from '@biuro/shared';
import { monthLabel } from '../close.ts';
import { useData, useMe, useNav, useSettings } from '../hooks.tsx';
import { CustomForm } from '../forms/CustomForm.tsx';
import { Empty, Icon } from '../ui.tsx';
import { DeadlineList, deadlines } from './common.tsx';

export function Terminy() {
  const { data } = useData();
  const me = useMe().data;
  const st = useSettings();
  const { go } = useNav();
  const [showDone, setShowDone] = useState(false);
  const [adding, setAdding] = useState(false);
  const cur = nowYM();
  const list = deadlines(st, data, ymAdd(cur, -1), ymAdd(cur, 12)).filter((d) => showDone || !(data.done[d.id] || d.before));
  const groups: Record<string, typeof list> = {};
  for (const d of list) (groups[ymd(d.due).slice(0, 7)] ||= []).push(d);

  return (
    <>
      <div className="vh">
        <div>
          <h1>Terminy</h1>
          <p>Przelew VAT, ryczałt, ZUS, dokumenty w inFakcie i dla biura, BDO i Twoje własne terminy. Termin w weekend lub święto przesuwa się na następny dzień roboczy.</p>
        </div>
        <div className="actions">
          <button className="btn" onClick={() => setAdding(true)}><Icon.plus />Własny termin</button>
        </div>
      </div>
      <div className="toolbar">
        <label className="chk"><input type="checkbox" checked={showDone} onChange={(e) => setShowDone(e.target.checked)} /> Pokaż zrobione</label>
        <span className="muted small">
          {me?.google.calendar
            ? 'Terminy są też w Twoim Kalendarzu Google.'
            : <>Terminy mogą trafiać do Kalendarza Google. <button className="linkish" onClick={() => go('firma')}>Połącz w zakładce Firma</button></>}
        </span>
      </div>
      {Object.keys(groups).length ? Object.entries(groups).map(([k, arr]) => (
        <section key={k}>
          <div className="monthhead"><h3>{monthLabel(k)}</h3><span className="count">{arr.length}</span></div>
          <div className="panel"><DeadlineList list={arr} data={data} /></div>
        </section>
      )) : <div className="panel"><Empty title="Wszystko zrobione">Zaznacz „Pokaż zrobione”, żeby zobaczyć zamknięte terminy.</Empty></div>}
      {adding && <CustomForm onClose={() => setAdding(false)} />}
    </>
  );
}
